import { State } from '@/store/state';
import appInfo from '@/utils/appInfo';
import { AGENT_CODE, CHANNEL_CODE } from '@/utils/consts';
import { NBGuidePopupTime } from '@/utils/emun';

const userType = (state: State) => ({
  isSpecialAgent: state.userType === 'special',
  isGuest: state.userType === 'guest',
  isHost: state.userType === 'normal',
  value: state.userType,
});
/** ------- 多语言 ------- */
// 默认找不到就用巴西语言。例如接口还没有回来的时候。
const languageId = (state: State) =>
  state.localeLangId ?? state.siteConfig?.language ?? '4';
const languageObj = (state: State, getters: any) =>
  state.languageList.find((v) => v.id === getters.languageId);
const languageShortName = (state: State, getters: any) =>
  getters.languageObj?.shortName ?? 'pt-BR';
/** ------- 多语言 ------- */
const cdnUrl = (state: State) => state.siteConfig?.cdnUrl;
const imageUrl = (state: State, getters: any) => (imagePath?: string) => {
  return getters.cdnUrl && imagePath ? getters.cdnUrl + imagePath : null;
};
// app下载地址
const appDownloadUrl = (state: State) => {
  const url = state.siteConfig?.appDownloadUrl;
  if (url) {
    try {
      const temp = new URL(url);
      if (appInfo.agentCode)
        temp.searchParams.set(AGENT_CODE, appInfo.agentCode);
      if (appInfo.channelCode)
        temp.searchParams.set(CHANNEL_CODE, appInfo.channelCode);
      return temp.toString();
    } catch {
      return url;
    }
  } else {
    return '';
  }
};
/** ------- 货币相关 ------- */
// 默认货币id
const currencyId = (state: State) => state.siteConfig?.siteCurrencyId ?? '6';
// 默认货币对象
const currencyObj = (state: State, getters: any) =>
  state.currencyList.find((v) => v.id === getters.currencyId);
// 默认货币名称
const currencyName = (state: State, getters: any) =>
  state.currencyList.find((v) => v.id === getters.currencyId)?.name ?? '';
// 指定货币id获取货币名称
const currencyNameWith = (state: State) => (currency: string) => {
  return state.currencyList.find((v) => v.id === currency)?.name ?? '';
};
// 默认货币小数位数
const currencyDecimalPlaces = (state: State, getters: any) =>
  Number(
    state.currencyList.find((v) => v.id === getters.currencyId)
      ?.decimalPlaces ?? '2'
  );
// 指定货币icon
const currencyIcon = (state: State) => (currency: string) =>
  state.currencyList.find((v) => v.id === currency)?.icon ?? '';
// 根据货币id获取货币小数位数
const specifiedDecimalPlaces =
  (state: State, getters: any) => (currencyId: string) => {
    const temp = state.currencyList.find(
      (v) => v.id === currencyId
    )?.decimalPlaces;
    if (temp) {
      return Number(temp);
    } else {
      return getters.currencyDecimalPlaces;
    }
  };
/** ------- 货币相关 ------- */
/** ------- 品牌相关 ------- */
// 平台logo
const brandLogo = (state: State, getters: any) =>
  getters.imageUrl(state.brandConfig?.logo);
const isAboutUsOpen = (state: State) => state.brandAboutUs?.status === '1';
/** ------- 品牌相关 ------- */
/** ------- 语言相关 ------- */
const languageItem = (state: State) => (languageId: string) => {
  return state.languageList.filter((v) => v.id == languageId)[0];
};
/** ------- 语言相关 ------- */
// 导航栏分类菜单 (過濾不顯示 show=0 & 升冪排序sort)
const gameNavigation = (state: State) => {
  const { siteConfig } = state;
  const nav = siteConfig?.gameNavigation ?? [];
  return nav
    .filter((v) => v.show === '1')
    .sort((a, b) => Number(a.sort) - Number(b.sort));
};
/** ------- 客服相关 ------- */
const customerCenterOpen = (state: State) =>
  state.customerConfig?.customerServiceCenterStatus === '1';
const customerOnlineOpen = (state: State) =>
  state.customerConfig?.customerServiceOnlineStatus === '1';
const customerPopupShow = (state: State, getters: any) =>
  getters.customerCenterOpen && state.serviceShow;
const customerSildebarShow = (state: State) =>
  state.customerConfig?.customerFloatingButtonStatus == '1';
/** ------- 客服相关 ------- */
/** ------- 引导弹窗 ------- */
const guideInstallEnableFor = (state: State) => (time: NBGuidePopupTime) => {
  return (
    state.guideInstall?.status === '1' && state.guideInstall.popupTime == time
    // !!state.guidePopupTime &&
    // state.guidePopupTime.findIndex((v) => v.id == time) != -1
  );
};
/** ------- 引导弹窗 ------- */
/** ------- 优惠假红点 ------- */
const shouldShowFooterPromoRedDot = (state: State, getters: any) => {
  if (!getters.loginSuccess || getters.userType.isGuest) {
    return false;
  }

  if (!state.footerPromoLastTime) {
    return true;
  }

  const lastDate = new Date(state.footerPromoLastTime);
  const todayDate = new Date();
  return !(
    lastDate.getFullYear() == todayDate.getFullYear() &&
    lastDate.getMonth() == todayDate.getMonth() &&
    lastDate.getDay() == todayDate.getDay()
  );
};
/** ------- 优惠假红点 ------- */

export default {
  userType,
  languageId,
  languageObj,
  languageShortName,
  cdnUrl,
  imageUrl,
  currencyId,
  currencyObj,
  currencyName,
  currencyNameWith,
  currencyDecimalPlaces,
  specifiedDecimalPlaces,
  brandLogo,
  isAboutUsOpen,
  languageItem,
  gameNavigation,
  customerCenterOpen,
  customerOnlineOpen,
  customerPopupShow,
  customerSildebarShow,
  currencyIcon,
  appDownloadUrl,
  guideInstallEnableFor,
  shouldShowFooterPromoRedDot,
};
